module.exports = __webpack_public_path__ + "static/media/trc-full-logo-condensed.80290c58.jpg";